
<script>
export default {
    functional: true,

    props: {
        tabindex: {
            type: Number,
            default: -1
        },
    },

    render(h, c) {
        return h('router-link', {
            class: `button button--purple button--cta-recruit`,
            props: {
                to: { 
                    name: 'recruit-slide' 
                },
            },
            attrs: {
                'data-flex': 'column',
                'tabindex': c.props.tabindex,
            },
        }, [
            h('span', 'How We'),
            h('span', 'Recruit Inclusively'),
        ])
    }
}
</script>

<style lang="scss" scoped>
.button > :nth-child(n) {
    line-height: 1.25;
}
.button {
    padding: 18px 36px;
    align-items: center;

    > :first-child {
        font-size: (12em / 16);
        font-weight: 500;
        letter-spacing: .075rem;
        transition: opacity 220ms;
        opacity: .7;
    }
    &:hover > :first-child {
        opacity: 1;
    }

    > :last-child {
        font-size: 1em;
        letter-spacing: .035rem;
    }

    @media( min-width: 768px ) and (max-width: 1366px) {
        padding: 12px 28px;
        font-size: 13px;
    }
    @media (min-width: 1367px) {
        font-size: 15px;
    }
}
</style>